import {
  Directive,
  ElementRef,
  Input,
  Renderer2,
  OnDestroy,
  AfterViewInit
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Directive({
  selector: '[lazyBg]'
})
export class LazyBackgroundDirective implements AfterViewInit, OnDestroy {
  @Input() lazyBg!: string;

  private observer!: IntersectionObserver;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private sanitizer: DomSanitizer
  ) { }

  ngAfterViewInit(): void {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.el.nativeElement.style.backgroundImage = `url('${this.lazyBg}')`;
        this.el.nativeElement.classList.add('lazy-bg-loaded');

        this.observer.disconnect();
      }
    });

    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}